// extracted by mini-css-extract-plugin
export default {"container":"EN-z","topReviewHeading":"FN-z","criticalReview":"GN-z","favorableReview":"HN-z","vsSeparator":"IN-z"};